import type { AggregatedTracker } from "@similarweb/sw-track";

import type { IApiHelper } from "app/common/services/apiHelper";
import type { ICategoryService } from "app/common/services/categoryService";
import type { CategoryId } from "app/common/services/categoryService.types";
import type { Translate } from "app/filters/i18nFilter";
import type { NavigatorType } from "single-spa/react-app/ProNavigator";
import type { UserCustomCategoryService } from "app/services/category/userCustomCategoryService";
import type { DefaultFetchService } from "app/services/fetchService";

/**
 * Navigation params, as provided by the navigator
 */
export interface ICategoryLeadersNavParams {
    category: CategoryId;
    categoryHash: string;
    country: string;
    duration: string;
    tab: string;
    webSource: string;
    parentCategory: string;
    key: Array<{
        id: string;
        name: string;
        image: string;
    }>;
}

/**
 * Category Leaders service, these are provided by the
 * CategoryLeadersContext
 */
export interface ICategoryLeadersServices {
    navigator: NavigatorType;
    categoryService: ICategoryService;
    customCategoryService: typeof UserCustomCategoryService;
    translate: Translate;
    apiHelper: IApiHelper;
    fetchService: DefaultFetchService;
    tracker: AggregatedTracker;
}

/**
 * Defines the required CategoryLeaders metric type from the API endpoint
 * (social/ads/referrals etc.)
 */
export enum ECategoryLeadersMetricType {
    CategoryLeadersAll,
    CategoryLeadersAds,
    CategoryLeadersDirect,
    CategoryLeadersMail,
    CategoryLeadersReferrals,
    CategoryLeadersSearch,
    CategoryLeadersSocial,
    CategoryLeadersGenAi,
    CategoryLeadersAffiliates,
}
